import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FotaBatchListComponent } from './fota-batch-list.component';

const routes: Routes = [
  {
    path: 'fota-batch-list',
    data: { name: 'FOTA Batch', isTab: false },
    component: FotaBatchListComponent,
  },
  {
    path: 'fota-batch-list/:uid',
    component: FotaBatchListComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FotaBatchListRoutingModule {}
